<div class="container">

    <!-- HEADER -->
    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
              <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
        </div>
        <div style="flex:1">
            <h1>Cadastrar Produto</h1>
            <p>Selecione um produto modelo para criar um novo produto a partir dele</p>
        </div>

        <div class="header-actions" *ngIf="etapa() === 'lista'">
            <button type="button" class="btn-config" (click)="abrirImportacao()" title="Importação de Estoque CSV">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                </svg>
            </button>
        </div>

        <!-- Ações do topo: mesmo padrão de pedido-venda.component.html, uma
             combinação de botões por etapa (Cancelar/Próximo, Voltar/Salvar,
             Cadastrar outro produto) -->
        <div style="display: flex; gap: 10px; align-items: center;" *ngIf="etapa() === 'form'">
            <button type="button" class="btn-salvar-header" [disabled]="loading()" (click)="salvar()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                  <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                </svg>
                Salvar
            </button>
            <button type="button"
              style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
              (click)="voltarLista()">
              Cancelar
            </button>
        </div>

        <div style="display: flex; gap: 10px; align-items: center;" *ngIf="etapa() === 'sucesso'">
            <button type="button" class="btn-salvar-header" (click)="novaDuplicacao()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Cadastrar outro produto
            </button>
            <button type="button" *ngIf="origemRetorno"
              style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
              (click)="voltarParaOrigem()">
              Voltar para {{ nomeOrigemRetorno }}
            </button>
        </div>
    </div>

    <!-- LOADING -->
    <div *ngIf="loading()" class="loading-overlay">
        <app-loading-indicator></app-loading-indicator>
        <span class="loading-text">{{loadingMsg() || 'Carregando...'}}</span>
    </div>

    <!-- ============================== -->
    <!-- ETAPA 1: LISTA DE MODELOS      -->
    <!-- ============================== -->
    <div class="card" *ngIf="etapa() === 'lista'">
        <div class="card-title">Produtos Modelo Para Clonar</div>

        <div class="busca-wrapper">
            <div class="busca-combo">
                <input type="text"
                       [(ngModel)]="termoBusca"
                       (ngModelChange)="onTermoChange()"
                       placeholder="Filtrar por descrição (ex: MODELO)..."
                       class="busca-combo-input">
                <button type="button" class="btn-busca btn-busca-right" (click)="buscarModelos()" title="Buscar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="7"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                </button>
            </div>
        </div>

        <div class="busca-empty" *ngIf="buscando()"><app-loading-indicator size="inline"></app-loading-indicator> Buscando produtos modelo...</div>
        <div class="busca-empty" *ngIf="!buscando() && modelos().length === 0">
            Nenhum produto modelo encontrado para o termo informado.
        </div>

        <div class="modelo-grid" *ngIf="!buscando() && modelos().length > 0">
            <div class="modelo-card" *ngFor="let m of modelosExibidos()" (click)="selecionarModelo(m, true)">
                <div class="modelo-img-container">
                    <img class="modelo-img" [src]="m.imagem ? 'data:image/jpeg;base64,' + m.imagem : gerarPlaceholder(m.descricao || m.nome || 'PRO')" alt="">
                    <span class="modelo-codigo">{{m.codprod || m.codigo}}</span>
                </div>
                <div class="modelo-info">
                    <span class="modelo-pn" *ngIf="m.refforn || m.partNumber">
                        PN: <span [innerHTML]="destacarTermo(m.refforn || m.partNumber || '')"></span>
                        <span *ngIf="m.ativo === 'N' || m.ativo === 'NÃO'" style="background-color: #ffcccc; color: #cc0000; padding: 2px 4px; font-weight: bold; font-size: 0.75em; border-radius: 4px; margin-left: 5px; white-space: nowrap; vertical-align: middle;">INATIVO</span>
                    </span>
                    <span class="modelo-descricao" [innerHTML]="destacarTermo(m.descricao || m.nome)"></span>
                </div>
                <span class="modelo-arrow">➔</span>
            </div>
        </div>

        <div class="ver-mais-wrapper" *ngIf="!buscando() && modelos().length > limiteModelos()">
            <button type="button" class="btn-ver-mais" (click)="verMaisModelos()">
                Ver mais ({{modelos().length - limiteModelos()}})
            </button>
        </div>
    </div>

    <!-- ============================== -->
    <!-- ETAPA 2: FORMULÁRIO            -->
    <!-- ============================== -->
    <div class="card" *ngIf="etapa() === 'form'">
        <div class="card-title">
            Cadastrar Produto — Origem: {{produtoOrigem?.codprod || produtoOrigem?.codigo}} - {{produtoOrigem?.descricao || produtoOrigem?.nome}}<span *ngIf="produtoOrigem?.refforn || produtoOrigem?.partNumber"> · PN: {{produtoOrigem?.refforn || produtoOrigem?.partNumber}}</span>
        </div>

        <div class="aviso-info" [class.aviso-info-oculto]="!avisoInfoVisivel()">
            ℹ Os campos abaixo foram pré-preenchidos com os dados do produto modelo. Edite o que for
            necessário antes de salvar. O código (CODPROD) será gerado automaticamente pelo Sankhya.
            Campos marcados com <span class="campo-obrigatorio-asterisco">*</span> são obrigatórios.
        </div>

        <div class="form-grid">

            <!-- ============================================================ -->
            <!-- LAYOUT REORGANIZADO (2026-10-06) conforme modelo enviado:    -->
            <!-- 1) Ativo/Imagem + Fabricante + Unidade + toggles             -->
            <!-- 2) PN + Descrição + CD                                       -->
            <!-- 3) Produtos Alternativos + Dados Internacionais + Local      -->
            <!-- 4) Polícia Federal + Pesos + NCM                             -->
            <!-- 5) Grupo + Margens                                           -->
            <!-- ============================================================ -->

            <!-- LINHA 1: Ativo/Imagem | Fabricante | Unidade | toggles -->
            <!-- Topo: imagem (esquerda) + 2 linhas de dados logo a frente dela -->
            <div class="field field-wide bloco-topo">
                <div class="bloco-ativo-img">
                    <div class="ativo-lado-esquerdo" *ngIf="campoPorField('ATIVO') as c">
                        <label class="switch">
                            <input type="checkbox" [checked]="c.valor === 'S'" (change)="onToggleAtivo(c, $event)" [name]="c.field">
                            <span class="slider"></span>
                            <span class="switch-text">{{ c.valor === 'S' ? 'Ativo' : 'Inativo' }}</span>
                        </label>
                    </div>

                    <div class="img-produto-mini">
                        <input type="file" accept="image/*" multiple class="img-file-hidden" #inputImagem (change)="onImagemSelecionada($event)">
                        <span class="img-count-badge"
                              *ngIf="(imagensPendentes.length || listaImagens.length) > 1">
                            {{imagensPendentes.length || listaImagens.length}}
                        </span>
                        <div class="img-produto-thumb"
                             (click)="imagensPendentes.length > 0 ? abrirSelecao() : inputImagem.click()"
                             [title]="imagensPendentes.length > 0 ? 'Ver imagens selecionadas' : 'Clique para adicionar imagem'">
                            <img [src]="imagemPrincipal ? imagemPrincipal.src : gerarPlaceholder(produtoOrigem?.descricao || produtoOrigem?.nome || 'PRO')"
                                 class="img-thumb-img" alt="Imagem do produto">
                        </div>
                    </div>
                </div>

                <div class="coluna-dados-topo">
            <div class="linha-topo-produto">

                <div class="campo-combo campo-marca" *ngIf="campoPorField('CODMARCA') as c">
                    <label>Fabricante (Marca)</label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirBuscaMarca()" title="Buscar Marca">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input"
                               [value]="valorExibidoMarca(c.valor)"
                               [title]="valorExibidoMarca(c.valor)"
                               (focus)="onFocusMarca($event)"
                               (input)="onInputMarca($event, c)"
                               (blur)="onBlurMarca($event, c)"
                               [name]="c.field">
                        <button type="button" class="busca-combo-clear" *ngIf="c.valor" (click)="limparMarca(c)" title="Limpar">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <div class="campo-margem-marca-info" *ngIf="margemMarcaAtual(c.valor) as mg">
                        Margem (Marca): Custo {{mg.custo}}% · Lucro {{mg.lucro}}%
                    </div>
                    <div class="campo-margem-marca-aviso" *ngIf="margemMarcaSemCadastro(c.valor)">
                        Margem de Custo/Lucro não cadastrada para esta Marca
                    </div>
                </div>

                <div class="campo-unidade" *ngIf="campoPorField('CODVOL') as c">
                    <label>{{c.label}}</label>
                    <select *ngIf="c.opcoes && c.opcoes.length" [(ngModel)]="c.valor" [name]="c.field"
                            [title]="labelOpcao(c, c.valor)">
                        <option value="">-- Selecione --</option>
                        <option *ngFor="let o of c.opcoes" [value]="o.valor">{{o.label}}</option>
                    </select>
                    <input *ngIf="!(c.opcoes && c.opcoes.length)" type="text" [(ngModel)]="c.valor" [name]="c.field"
                           [title]="c.valor" (blur)="trimCampo(c)">
                </div>

                <!-- Toggles: Lote / Série / CORE / Controla FORM / Perigoso -->
                <div class="grupo-toggles-topo">
                    <div class="tipcontest-grupo" *ngIf="campoPorField('TIPCONTEST') as c">
                        <label class="switch switch-compacto">
                            <input type="checkbox" [checked]="c.valor === 'L'" (change)="onToggleTipoControle(c, 'L', $event)" [name]="c.field + '_lote'">
                            <span class="slider"></span>
                            <span class="switch-text">Lote</span>
                        </label>
                        <label class="switch switch-compacto">
                            <input type="checkbox" [checked]="c.valor === 'E'" (change)="onToggleTipoControle(c, 'E', $event)" [name]="c.field + '_serie'">
                            <span class="slider"></span>
                            <span class="switch-text">Serial</span>
                        </label>
                    </div>

                    <div class="campo-controla-form" *ngIf="campoPorField('AD_CONTROLAFORM') as c">
                        <label class="switch switch-compacto">
                            <input type="checkbox" [checked]="c.valor === 'S'" (change)="onToggleAtivo(c, $event)" [name]="c.field">
                            <span class="slider"></span>
                            <span class="switch-text">Controla FORM</span>
                        </label>
                    </div>

                    <ng-container *ngIf="campoPorField('GPL_MAT_PERIG') as cp">
                        <label class="switch switch-compacto">
                            <input type="checkbox" [checked]="cp.valor === 'S'" (change)="onToggleCheckbox(cp, $event)" [name]="cp.field">
                            <span class="slider"></span>
                            <span class="switch-text">{{cp.label}}</span>
                        </label>
                    </ng-container>

                </div>
            </div>

            <!-- LINHA 2: PN + Descrição + CD -->
            <div class="field field-wide linha-principal linha-pn-desc-cd">
                <div class="campo-pn" *ngIf="campoPorField('REFFORN') as c">
                    <label [class.label-invalido]="(c.valor?.trim()?.length ?? 0) < 3">
                        {{c.label}} <span class="campo-obrigatorio-asterisco">*</span>
                    </label>
                    <input type="text" style="text-transform: uppercase;" [ngModel]="c.valor" (ngModelChange)="c.valor = ($event || '').toUpperCase()" [name]="c.field"
                           [class.campo-invalido]="(c.valor?.trim()?.length ?? 0) < 3"
                           (blur)="trimCampo(c)">
                </div>

                <div class="campo-descricao-principal" *ngIf="campoPorField('DESCRPROD') as c">
                    <label [class.label-invalido]="(c.valor?.trim()?.length ?? 0) < 5">
                        {{c.label}} <span class="campo-obrigatorio-asterisco">*</span>
                    </label>
                    <input type="text" style="text-transform: uppercase;" [ngModel]="c.valor" (ngModelChange)="onDescricaoChange(c, $event)"
                           [name]="c.field"
                           [class.campo-invalido]="(c.valor?.trim()?.length ?? 0) < 5"
                           (blur)="trimCampo(c)">
                </div>

                <div class="campo-cd-pequeno campo-cd-direita" *ngIf="campoPorField('AD_CONDICAO') as c">
                    <label>{{c.label}}</label>
                    <select *ngIf="c.opcoes && c.opcoes.length" [(ngModel)]="c.valor" [name]="c.field"
                            [title]="labelOpcao(c, c.valor)">
                        <option value="">-- Selecione --</option>
                        <option *ngFor="let o of c.opcoes" [value]="o.valor">{{o.label}}</option>
                    </select>
                    <input *ngIf="!(c.opcoes && c.opcoes.length)" type="text" [(ngModel)]="c.valor" [name]="c.field"
                           [title]="c.valor" (blur)="trimCampo(c)">
                </div>
            </div>
                </div><!-- /coluna-dados-topo -->
            </div><!-- /bloco-topo -->

            <!-- LINHA 3: Produtos Alternativos | Dados Internacionais | Local -->
            <div class="field field-wide linha-alt-intl-local">

                <div class="coluna-alternativos">
                    <label>Produtos Alternativos</label>
                    <div class="produtos-alternativos-select" (click)="modalProdutosAlternativosAberto = true; buscarProdutosAlternativosModal()">
                        <div class="produtos-alternativos-valores">
                            <span class="produtos-alternativos-placeholder" *ngIf="!produtosAlternativosSelecionados.length">
                                Selecione produtos alternativos...
                            </span>
                            <span class="produto-alternativo-chip" *ngFor="let prod of produtosAlternativosSelecionados" (click)="$event.stopPropagation()">
                                PN: {{ prod.partNumber || prod.codprod }}
                                <button type="button" class="produto-alternativo-remover" (click)="alternarProdutoAlternativoCadastro(prod)" title="Remover">x</button>
                            </span>
                        </div>
                        <div class="produtos-alternativos-seta"></div>
                    </div>
                </div>

                <div class="card-dados-intl">
                    <span class="card-dados-intl-titulo">DADOS INTERNACIONAIS</span>
                    <div class="campo-label-usa" *ngIf="campoPorField('GPL_LABEL') as c">
                        <label>{{c.label}}</label>
                        <input type="text" style="text-transform: uppercase;" [ngModel]="c.valor" (ngModelChange)="onLabelUsaChange(c, $event)" [name]="c.field"
                               (blur)="trimCampo(c)">
                    </div>
                    <div class="card-dados-intl-linha">
                        <div class="campo-texto-pequeno" *ngIf="campoPorField('AD_ECCN') as c">
                            <label>{{c.label}}</label>
                            <input type="text" style="text-transform: uppercase;" [ngModel]="c.valor" (ngModelChange)="c.valor = ($event || '').toUpperCase()" [name]="c.field" (blur)="trimCampo(c)">
                        </div>
                        <div class="campo-texto-pequeno" *ngIf="campoPorField('AD_SCHEDULEB') as c">
                            <label>{{c.label}}</label>
                            <input type="text" [(ngModel)]="c.valor" [name]="c.field" (blur)="trimCampo(c)">
                        </div>
                        <!-- Unit of Measure: sigla em inglês da Unidade (TGFVOL.GPL_SIGLAINGLES), automática -->
                        <div class="campo-texto-pequeno campo-unit-measure">
                            <label>Unit of Measure:</label>
                            <input type="text" class="readonly-field campo-unit-measure-input" readonly
                                   [value]="unidadeInglesAtual()?.siglaIngles || ''"
                                   [title]="unidadeInglesAtual()?.nomeIngles || ''"
                                   name="unitOfMeasure" tabindex="-1">
                        </div>
                    </div>
                </div>

                <div class="coluna-local-grupo">
                    <div class="campo-combo" *ngIf="campoPorField('CODLOCALPADRAO') as c">
                        <label>{{c.label}}</label>
                        <div class="busca-combo">
                            <button type="button" class="btn-busca" (click)="abrirBuscaLocal()" title="Buscar Local">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="7"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            </button>
                            <input type="text" class="busca-combo-input"
                                   [value]="valorExibidoLocal(c.valor)"
                                   [title]="valorExibidoLocal(c.valor)"
                                   (input)="onInputLocal($event, c)"
                                   [name]="c.field">
                            <button type="button" class="busca-combo-clear" *ngIf="c.valor" (click)="limparLocal(c)" title="Limpar">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="campo-combo campo-grupo-abaixo-local" *ngIf="campoPorField('CODGRUPOPROD') as c">
                        <label>{{c.label}}</label>
                        <div class="busca-combo">
                            <button type="button" class="btn-busca" (click)="abrirBuscaGrupo()" title="Buscar Grupo de Produto">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="7"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            </button>
                            <input type="text" class="busca-combo-input"
                                   [value]="valorExibidoGrupo(c.valor)"
                                   [title]="valorExibidoGrupo(c.valor)"
                                   (input)="onInputGrupo($event, c)"
                                   [name]="c.field">
                            <button type="button" class="busca-combo-clear" *ngIf="c.valor" (click)="limparGrupo(c)" title="Limpar">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- LINHA 4: Polícia Federal | Peso Bruto | Peso Líquido | NCM -->
            <div class="field field-wide linha-pf-perigoso-ncm linha-pf-pesos-ncm">

                <!-- Card Polícia Federal -->
                <div class="policia-federal-card" title="PORTARIA Nº 240, DE 12 DE MARÇO DE 2019&#10;&#10;IV - São isentas de controle as soluções eletrolíticas de bateria formuladas à base de até 40% de ácido sulfúrico, destinadas ao varejo e em embalagens de até 1 (um) litro, sendo o limite de isenção para pessoa jurídica a quantidade de 200 (duzentos) litros e para a pessoa física a quantidade de 5 (cinco) litros, por mês.">
                    <span class="policia-federal-titulo">POLÍCIA FEDERAL</span>
                    <div class="policia-federal-body">
                        <div class="campo-toggle" *ngIf="campoPorField('GPL_CONTROLADO') as c">
                            <label class="switch switch-compacto">
                                <input type="checkbox" [checked]="c.valor === 'S'" (change)="onToggleControlado(c, $event)" [name]="c.field">
                                <span class="slider"></span>
                                <span class="switch-text">{{c.label}}</span>
                            </label>
                        </div>
                        <div class="campo-limite" *ngIf="campoPorField('GPL_CTRL_LIM_PF') as c">
                            <label>{{c.label}}</label>
                            <input type="text" class="readonly-field"
                                   [value]="controladoAtivo() ? valorExibidoLimite(c.valor) : ''"
                                   disabled [name]="c.field">
                        </div>
                        <div class="campo-limite" *ngIf="campoPorField('GPL_CTRL_LIM_PJ') as c">
                            <label>{{c.label}}</label>
                            <input type="text" class="readonly-field"
                                   [value]="controladoAtivo() ? valorExibidoLimite(c.valor) : ''"
                                   disabled [name]="c.field">
                        </div>
                    </div>
                </div>

                <div class="campo-peso" *ngIf="campoPorField('PESOBRUTO') as c">
                    <label>{{c.label}}</label>
                    <input type="text" inputmode="decimal" [(ngModel)]="c.valor" [name]="c.field"
                           (focus)="onPesoFocus(c)" (blur)="onPesoBlur(c)">
                </div>
                <div class="campo-peso" *ngIf="campoPorField('PESOLIQ') as c">
                    <label>{{c.label}}</label>
                    <input type="text" inputmode="decimal" [(ngModel)]="c.valor" [name]="c.field"
                           (focus)="onPesoFocus(c)" (blur)="onPesoBlur(c)">
                </div>

                <div class="campo-combo campo-ncm-editavel" *ngIf="campoPorField('NCM') as c">
                    <label>{{c.label}}</label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirBuscaNcm()" title="Buscar NCM">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input"
                               [value]="valorExibidoNcm(c.valor)"
                               [title]="valorExibidoNcm(c.valor)"
                               (input)="onInputNcm($event, c)"
                               [name]="c.field">
                        <button type="button" class="busca-combo-clear" *ngIf="c.valor" (click)="limparNcm(c)" title="Limpar">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>


            <!-- PREÇO + COTAÇÃO (antiga 2ª etapa "Próximo", agora na mesma tela) -->
            <div class="field field-wide preco-inline">
                <div class="preco-grid" [class.preco-nacional]="isMarcaNacional()">
                    <div class="preco-campo">
                        <label>Preço Fabricante {{ moedaPreco() }}</label>
                        <input type="text" [(ngModel)]="precoForm.precoFabricante" name="precoFabricante"
                               (blur)="onBlurPrecoFabricante()"
                               (focus)="removerVirgula('precoFabricante')">
                    </div>
                    <div class="preco-campo">
                        <label>Custo (%)</label>
                        <input type="text" [(ngModel)]="precoForm.percentualCusto" name="percentualCusto"
                               (blur)="calcularPreco()"
                               (focus)="removerVirgula('percentualCusto')">
                    </div>
                    <div class="preco-campo">
                        <label>Total Custo {{ moedaPreco() }}</label>
                        <input type="text" [(ngModel)]="precoForm.totalCusto" name="totalCusto" readonly class="preco-readonly">
                    </div>
                    <div class="preco-campo">
                        <label>Lucro (%)</label>
                        <input type="text" [(ngModel)]="precoForm.percentualLucro" name="percentualLucro"
                               (blur)="calcularPreco()"
                               (focus)="removerVirgula('percentualLucro')">
                    </div>
                    <div class="preco-campo">
                        <label>Preço Venda {{ moedaPreco() }}</label>
                        <input type="text" [(ngModel)]="precoForm.precoVenda" name="precoVenda" readonly class="preco-readonly">
                    </div>
                    <div class="preco-campo" *ngIf="!isMarcaNacional()">
                        <label [title]="cotacaoDolarDia() > 0 ? ('Cotação do dólar: R$ ' + (cotacaoDolarDia() | number:'1.2-2':'pt-BR')) : 'Cotação do dólar indisponível'">
                            Preço Venda R$
                            <span class="cotacao-dolar-label" *ngIf="cotacaoDolarDia() > 0">
                                (Cotação: U$ {{ cotacaoDolarDia() | number:'1.2-2':'pt-BR' }})
                            </span>
                        </label>
                        <input type="text" [value]="precoVendaEmReais() || '—'" name="precoVendaReais" readonly class="preco-readonly">
                    </div>
                    <div class="preco-campo preco-campo-core">
                        <label class="switch switch-compacto core-toggle" *ngIf="campoPorField('AD_CONTROLACORE') as cc" title="Controla CORE">
                            <input type="checkbox" [checked]="cc.valor === 'S'" (change)="onToggleAtivo(cc, $event)" [name]="cc.field + '_preco'">
                            <span class="slider"></span>
                        </label>
                        <div class="core-coluna">
                            <label class="core-titulo">Core {{ moedaPreco() }}</label>
                            <input type="text" [(ngModel)]="precoForm.valorCore" name="valorCore"
                                   [class.preco-readonly]="getCampoValor('AD_CONTROLACORE') !== 'S'"
                                   [disabled]="getCampoValor('AD_CONTROLACORE') !== 'S'"
                                   (blur)="formatarCampoPreco('valorCore')"
                                   (focus)="removerVirgula('valorCore')">
                        </div>
                    </div>
                </div>

                <div class="aviso-reais" *ngIf="isMarcaNacional()">
                    <span class="bandeira-brasil" aria-label="Bandeira do Brasil">
                        <span class="bandeira-losango"><span class="bandeira-circulo"></span></span>
                    </span>
                    <span class="aviso-reais-icone"><span>!</span></span>
                    <span class="aviso-reais-texto">OS VALORES DESTE FABRICANTE DEVEM SER DEFINIDOS EM REAIS R$.</span>
                    <span class="aviso-reais-icone"><span>!</span></span>
                    <span class="bandeira-brasil" aria-label="Bandeira do Brasil">
                        <span class="bandeira-losango"><span class="bandeira-circulo"></span></span>
                    </span>
                </div>

                <div class="preco-campo preco-fornecedor" style="position:relative;">
                    <label>Cotação Realizada Em:</label>
                    <input type="text" [(ngModel)]="precoForm.fornecedor" name="fornecedorPreco"
                           autocomplete="off"
                           (focus)="abrirFornecedoresPreco()"
                           (ngModelChange)="buscarFornecedoresPreco(precoForm.fornecedor)">
                    <ul class="preco-dropdown" *ngIf="fornecedorDropdownAberto && listaFornecedoresPreco.length">
                        <li *ngFor="let f of listaFornecedoresPreco"
                            (mousedown)="$event.preventDefault(); selecionarFornecedorPreco(f)">
                            {{f.descricao}}{{ f.cnpj ? ' - ' + fmtDocFornecedor(f.cnpj) : '' }}
                        </li>
                    </ul>
                </div>

                <ng-container *ngIf="avisoSemPrecoVisivel() && precoToNumber(precoForm.precoFabricante) === 0">
                    <span class="preco-aviso-sempreco">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                        Preço não informado — cotação <strong>não será gravada</strong>
                    </span>
                </ng-container>
            </div>

            <!-- DEMAIS CAMPOS: ordem padrão definida em CAMPOS_DUPLICACAO -->
            <ng-container *ngFor="let c of campos()">
            <div class="field" *ngIf="!emLayoutFixo(c.field)" [class.field-descricao]="c.field === 'GPL_LABEL'">
                <label>{{c.label}}</label>

                <!-- Campos com lista de opções (combo): AD_CONDICAO -->
                <select *ngIf="c.opcoes && c.opcoes.length" [(ngModel)]="c.valor" [name]="c.field">
                    <option value="">-- Selecione --</option>
                    <option *ngFor="let o of c.opcoes" [value]="o.valor">{{o.label}}</option>
                </select>

                <!-- Label (USA) (DESCRESTRAG): marca edição manual para não ser sobrescrito pela tradução automática -->
                <input *ngIf="c.field === 'GPL_LABEL'"
                       type="text" [ngModel]="c.valor" (ngModelChange)="onLabelUsaChange(c, $event)" [name]="c.field"
                       (blur)="trimCampo(c)">

                <!-- Campo de texto padrão -->
                <input *ngIf="c.field !== 'GPL_LABEL' && !(c.opcoes && c.opcoes.length)"
                       type="text" [(ngModel)]="c.valor" [name]="c.field" (blur)="trimCampo(c)">
            </div>
            </ng-container>
        </div><!-- /form-grid -->

        <!-- Observações: Interna + Técnica -->
        <div class="obs-grid">
            <div class="obs-campo" *ngIf="campoPorField('AD_OBSINT') as c">
                <label>{{c.label}}</label>
                <textarea [(ngModel)]="c.valor" [name]="c.field" rows="4"></textarea>
            </div>
            <div class="obs-campo" *ngIf="campoPorField('AD_OBSTEC') as c">
                <label>{{c.label}}</label>
                <textarea [(ngModel)]="c.valor" [name]="c.field" rows="4"></textarea>
            </div>
        </div>
    </div>

    <!-- ============================== -->
    <!-- ETAPA 4: SUCESSO               -->
    <!-- ============================== -->
    <div class="resultado-card" *ngIf="etapa() === 'sucesso'" style="cursor: pointer;" title="Clique para abrir este produto na tela de Edição de Produtos" (click)="abrirEdicaoDoProdutoCriado()">
        <h3>✔ Produto Cadastrado com Sucesso!</h3>
        <div class="nota-info">
            <div class="nota-badge">
                <div class="sucesso-info-grid">
                    <ng-container *ngIf="getCampoValor('REFFORN') as pn">
                        <span class="sucesso-label">P/N</span>
                        <span class="sucesso-valor">{{pn}}</span>
                    </ng-container>
                    <ng-container *ngIf="getCampoValor('MARCA') as fab">
                        <span class="sucesso-label">FABRICANTE</span>
                        <span class="sucesso-valor">{{fab}}</span>
                    </ng-container>
                    <ng-container *ngIf="getCampoValor('AD_CONDICAO') as cd">
                        <span class="sucesso-label">CD</span>
                        <span class="sucesso-valor">{{cd}}</span>
                    </ng-container>
                    <span class="sucesso-label">CÓDIGO</span>
                    <span class="sucesso-valor">{{novoCodProd()}}</span>
                </div>
            </div>
            <span style="display:block;margin-top:8px;font-size:12px;color:#5a7d9a;">Clique aqui para editar este produto →</span>
        </div>
    </div>

</div>

<!-- ================================================================ -->
<!-- Modal: Seleção de imagens pendentes (antes de salvar produto) -->
<!-- ================================================================ -->
<div class="img-modal-overlay" *ngIf="mostrarModalSelecao">
    <div class="img-selecao-box">

        <!-- Cabeçalho -->
        <div class="img-selecao-header">
            <span>Imagens selecionadas</span>
            <span class="img-selecao-contador" *ngIf="imagensPendentes.length > 1">
                {{indexVisualizandoPendente + 1}} / {{imagensPendentes.length}}
            </span>
        </div>

        <!-- Imagem principal em tamanho completo -->
        <div class="img-selecao-principal">
            <img [src]="imagensPendentes[indexVisualizandoPendente]?.src" class="img-selecao-preview" alt="">
            <!-- Badge PADRÃO sobreposto -->
            <span class="img-selecao-badge-principal" *ngIf="indexPadrao === indexVisualizandoPendente">PADRÃO</span>
            <!-- Botão remover (quando só há 1 imagem, sem tira de miniaturas) -->
            <button type="button" class="img-selecao-remove-principal"
                    *ngIf="imagensPendentes.length === 1"
                    (click)="removerImagemPendente(0, $event)" title="Remover imagem">✕</button>
        </div>

        <!-- Tira de miniaturas (apenas quando há mais de 1) -->
        <div class="img-selecao-tira" *ngIf="imagensPendentes.length > 1">
            <div class="img-selecao-mini"
                 *ngFor="let img of imagensPendentes; let i = index"
                 [class.ativa]="i === indexVisualizandoPendente"
                 [class.padrao]="i === indexPadrao"
                 (click)="indexVisualizandoPendente = i">
                <img [src]="img.src" alt="">
                <span class="img-mini-padrao-badge" *ngIf="indexPadrao === i">✓</span>
                <button type="button" class="img-selecao-remove"
                        (click)="removerImagemPendente(i, $event)" title="Remover">✕</button>
            </div>
        </div>

        <!-- Aviso padrão obrigatório -->
        <div class="img-selecao-hint-obrig" *ngIf="indexPadrao < 0">
            ⚠ Selecione a imagem padrão para continuar
        </div>

        <!-- Ações -->
        <div class="img-selecao-actions">
            <input type="file" accept="image/*" multiple class="img-file-hidden" #inputAdicionar (change)="onImagemSelecionada($event)">
            <button class="img-btn default" type="button"
                    [class.ja-padrao]="indexPadrao === indexVisualizandoPendente"
                    (click)="indexPadrao = indexVisualizandoPendente">
                {{indexPadrao === indexVisualizandoPendente ? '✓ Padrão' : 'Definir Padrão'}}
            </button>
            <button class="img-btn default" type="button" (click)="inputAdicionar.click()">+ Adicionar</button>
            <button class="img-btn cancel" type="button" (click)="cancelarSelecaoImagens()">Limpar</button>
            <button class="img-btn save" type="button"
                    [disabled]="indexPadrao < 0"
                    (click)="confirmarSelecaoImagens()">Confirmar</button>
        </div>
    </div>
</div>

<!-- ======================================================== -->
<!-- Modal: Galeria de imagens                                -->
<!-- ======================================================== -->
<div class="img-modal-overlay" *ngIf="modalGaleria" (click)="fecharGaleria()">
    <div class="img-galeria-box" (click)="$event.stopPropagation()">

        <!-- Contador -->
        <div class="img-galeria-contador" *ngIf="listaImagens.length > 1">
            {{indexImagem + 1}} / {{listaImagens.length}}
        </div>

        <!-- Imagem principal com setas sobrepostas -->
        <div class="img-galeria-principal">
            <button class="nav-btn left" *ngIf="listaImagens.length > 1" (click)="imagemAnterior()">◀</button>
            <img [src]="imagemAtual?.src" class="img-galeria-preview" alt="Imagem do produto"/>
            <button class="nav-btn right" *ngIf="listaImagens.length > 1" (click)="proximaImagem()">▶</button>
        </div>

        <!-- Tira de miniaturas (só exibe quando há mais de 1) -->
        <div class="img-galeria-tira" *ngIf="listaImagens.length > 1">
            <div class="img-galeria-mini"
                 *ngFor="let img of listaImagens; let i = index"
                 [class.ativa]="i === indexImagem"
                 (click)="irParaImagem(i)">
                <img [src]="img.src" alt="">
            </div>
        </div>

        <!-- Ações -->
        <div class="img-modal-actions">
            <button class="img-btn default" (click)="definirComoPadrao(imagemAtual, true)">DEFINIR PADRÃO</button>
            <button class="img-btn cancel"
                    (click)="deletarImgProduto(imagemAtual!)"
                    [disabled]="!imagemAtual || ehPlaceholder(imagemAtual)">
                EXCLUIR
            </button>
            <button class="img-btn cancel" (click)="fecharGaleria()">FECHAR</button>
        </div>
    </div>
</div>

<!-- ======================================================== -->
<!-- Modal "Copiar Também" (pré-save, estilo Sankhya nativo) -->
<!-- ======================================================== -->
<div class="modal-overlay" *ngIf="copiaTambemModalAberta()">
    <div class="modal-box modal-copia">
        <div class="modal-header">Copiar Também</div>
        <div class="modal-body">
            <p class="copia-instrucao">Selecione as informações que devem ser copiadas do produto modelo para o novo produto:</p>

            <!-- Todos -->
            <label class="copia-opcao copia-todos">
                <input type="checkbox"
                       [checked]="todasOpcoesSelecionadas()"
                       (change)="toggleTodosOpcoesCopia($any($event.target).checked)">
                <span>Todos</span>
            </label>

            <div class="copia-divisor"></div>

            <!-- Opções individuais -->
            <label class="copia-opcao" *ngFor="let o of opcoesCopia()">
                <input type="checkbox"
                       [checked]="o.selecionada"
                       (change)="toggleOpcaoCopia(o.chave, $any($event.target).checked)">
                <span>{{o.label}}</span>
            </label>
        </div>
        <div class="modal-footer">
            <button class="modal-btn" (click)="cancelarCopiaTambem()">Cancelar</button>
            <button class="modal-btn confirm" (click)="confirmarSalvar()">Salvar</button>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!-- Modal de Resultados das Cópias (exibido após salvar, se aplicável) -->
<!-- ================================================================ -->
<div class="modal-overlay" *ngIf="resultadosCopiaModalAberta()">
    <div class="modal-box modal-resultados-copia">
        <div class="modal-header">Resultado — Copiar Também</div>
        <div class="modal-body">
            <div class="copia-resultado-item" *ngFor="let r of resultadosCopia()">
                <span class="copia-resultado-icone" [class.ok]="r.ok" [class.erro]="!r.ok">
                    {{r.ok ? '✔' : '✖'}}
                </span>
                <span class="copia-resultado-label">{{r.label}}</span>
                <span class="copia-resultado-qtd" *ngIf="r.ok && r.qtd > 0 && r.chave !== 'impostos'">
                    ({{r.qtd}} registro{{r.qtd !== 1 ? 's' : ''}} copiado{{r.qtd !== 1 ? 's' : ''}})
                </span>
                <span class="copia-resultado-qtd" *ngIf="r.ok && r.qtd > 0 && r.chave === 'impostos'">
                    ({{r.qtd}} campo{{r.qtd !== 1 ? 's' : ''}} importado{{r.qtd !== 1 ? 's' : ''}})
                </span>
                <span class="copia-resultado-qtd" *ngIf="r.ok && r.qtd === 0">
                    (nenhum registro encontrado)
                </span>
                <span class="copia-resultado-erro" *ngIf="!r.ok && r.erro">
                    — {{r.erro}}
                </span>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharResultadosCopia()">OK</button>
        </div>
    </div>
</div>

<!-- Modal de Alerta -->
<div class="modal-overlay" *ngIf="alertaModal()">
    <div class="modal-box">
        <div class="modal-header" [ngClass]="alertaTipo()">
            <span *ngIf="alertaTipo() === 'sucesso'">✔ Sucesso</span>
            <span *ngIf="alertaTipo() === 'erro'">❌ Erro</span>
            <span *ngIf="alertaTipo() === 'aviso'">⚠ Aviso</span>
        </div>
        <div class="modal-body">
            <p>{{alertaTexto()}}</p>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharAlerta()">OK</button>
        </div>
    </div>
</div>

<!-- Modal de Busca de Marca (igual ao "Procurando por Marca" do Sankhya) -->
<div class="modal-overlay" [class.fabricante-modal-overlay]="marcaModalDestino === 'alternativo'" *ngIf="marcaModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Marca</div>
        <div class="modal-body">
            <input type="text"
                   class="busca-modal-input"
                   [ngModel]="filtroMarca()"
                   (ngModelChange)="filtroMarca.set($event)"
                   placeholder="Digite o que você procura"
                   autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item"
                     *ngFor="let m of marcasFiltradas()"
                     (click)="selecionarMarca(m)">
                    {{m.label}}
                </div>
                <div class="busca-modal-empty" *ngIf="marcasFiltradas().length === 0">
                    Nenhuma marca encontrada.
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharBuscaMarca()">Cancelar</button>
        </div>
    </div>
</div>

<!-- Modal de Busca de Grupo de Produto (igual ao "Procurando por Grupo de Produto" do Sankhya) -->
<div class="modal-overlay" *ngIf="grupoModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Grupo de Produto</div>
        <div class="modal-body">
            <input type="text"
                   class="busca-modal-input"
                   [ngModel]="filtroGrupo()"
                   (ngModelChange)="filtroGrupo.set($event)"
                   placeholder="Digite o que você procura"
                   autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item"
                     *ngFor="let g of gruposFiltrados()"
                     (click)="selecionarGrupo(g)">
                    {{g.label}}
                </div>
                <div class="busca-modal-empty" *ngIf="gruposFiltrados().length === 0">
                    Nenhum grupo encontrado.
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharBuscaGrupo()">Cancelar</button>
        </div>
    </div>
</div>

<!-- Modal de Busca de Local de Estoque -->
<div class="modal-overlay" *ngIf="localModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por Local</div>
        <div class="modal-body">
            <input type="text"
                   class="busca-modal-input"
                   [ngModel]="filtroLocal()"
                   (ngModelChange)="filtroLocal.set($event)"
                   placeholder="Digite o que você procura"
                   autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item"
                     *ngFor="let l of locaisFiltrados()"
                     (click)="selecionarLocal(l)">
                    {{l.label}}
                </div>
                <div class="busca-modal-empty" *ngIf="locaisFiltrados().length === 0">
                    Nenhum local encontrado.
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharBuscaLocal()">Cancelar</button>
        </div>
    </div>
</div>

<!-- Modal de Busca de NCM -->
<div class="modal-overlay" *ngIf="ncmModalAberta()">
    <div class="modal-box">
        <div class="modal-header">Procurando por NCM</div>
        <div class="modal-body">
            <input type="text"
                   class="busca-modal-input"
                   [ngModel]="filtroNcm()"
                   (ngModelChange)="filtroNcm.set($event)"
                   placeholder="Digite pelo menos 3 caracteres para buscar"
                   autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item"
                     *ngFor="let n of ncmsFiltrados()"
                     (click)="selecionarNcm(n)">
                    {{n.label}}
                </div>
                <div class="busca-modal-empty" *ngIf="ncmsFiltrados().length === 0">
                    <span *ngIf="filtroNcm().trim().length < 3">Digite ao menos 3 caracteres para filtrar.</span>
                    <span *ngIf="filtroNcm().trim().length >= 3">Nenhum NCM encontrado.</span>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharBuscaNcm()">Cancelar</button>
        </div>
    </div>
</div>

<!-- Modal de Importação CSV — 3 Tabelas -->
<div class="modal-overlay imp-overlay" *ngIf="importacaoModalAberta()">
  <div class="modal-box imp-modal-box" (click)="$event.stopPropagation()">

    <!-- Cabeçalho -->
    <div class="imp-header">
      <span class="imp-title">Importação de Estoque</span>
      <button class="imp-close" (click)="fecharImportacao()">✕</button>
    </div>

    <!-- Abas -->
    <div class="imp-tabs">
      <button class="imp-tab" [class.active]="importAba==='base'"
              (click)="importAba='base'">
        <span class="imp-tab-badge" [class.ok]="csvBaseImportado()>0">{{csvBaseImportado()>0 ? '✓ '+csvBaseImportado() : '1'}}</span>
        IMP_BASE
      </button>
      <button class="imp-tab" [class.active]="importAba==='forms'"
              (click)="importAba='forms'">
        <span class="imp-tab-badge" [class.ok]="csvFormsImportado()>0">{{csvFormsImportado()>0 ? '✓ '+csvFormsImportado() : '2'}}</span>
        IMP_FORMS
      </button>
      <button class="imp-tab" [class.active]="importAba==='seriais'"
              (click)="importAba='seriais'">
        <span class="imp-tab-badge" [class.ok]="csvSeraisImportado()>0">{{csvSeraisImportado()>0 ? '✓ '+csvSeraisImportado() : '3'}}</span>
        IMP_SERIAIS
      </button>
      <button class="imp-tab" [class.active]="importAba==='nota'"
              [disabled]="!podeAbrirNota"
              (click)="importAba='nota'">
        <span class="imp-tab-badge" [class.ok]="execResultado.length>0">{{execResultado.length>0 ? '✓' : '4'}}</span>
        Gerar Nota
      </button>
    </div>

    <!-- ─── ABA IMP_BASE ─────────────────────────────────────────── -->
    <div class="imp-body" *ngIf="importAba==='base'">
      <p class="imp-desc">
        Uma linha por produto/empresa. Colunas: <code>SEQUENCIA, APE_ID, EMP_ID, EST_LOCAL, EST_QTDE, EST_CUSTO, VALOR_DE_VENDA</code>
      </p>
      <div class="imp-upload-row">
        <label class="btn-upload">
          {{ csvBaseNome() || 'Selecionar CSV' }}
          <input type="file" accept=".csv" style="display:none" (change)="onFileChangeCsvBase($event)">
        </label>
        <span class="imp-status ok" *ngIf="csvBaseImportado()>0">✓ {{csvBaseImportado()}} registros na tabela</span>
      </div>

      <div class="map-grid" *ngIf="csvBaseHeaders.length">
        <div class="map-row">
          <label>SEQUENCIA <span class="req">*</span></label>
          <select [(ngModel)]="mapBase.sequencia">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>APE_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapBase.apeId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EMP_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapBase.empId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EST_LOCAL</label>
          <select [(ngModel)]="mapBase.estLocal">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EST_QTDE <span class="req">*</span></label>
          <select [(ngModel)]="mapBase.estQtde">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EST_CUSTO</label>
          <select [(ngModel)]="mapBase.estCusto">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>VALOR_DE_VENDA</label>
          <select [(ngModel)]="mapBase.valorDeVenda">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvBaseHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
      </div>

      <div class="imp-footer">
        <button class="modal-btn confirm"
                [disabled]="!csvBaseHeaders.length || csvBaseImportando()"
                (click)="importarBase()"><app-loading-indicator *ngIf="csvBaseImportando()" size="inline"></app-loading-indicator>
          {{ csvBaseImportando() ? 'Importando...' : 'Importar IMP_BASE' }}
        </button>
        <button class="modal-btn" (click)="importAba='forms'" [disabled]="csvBaseImportado()===0">
          Próximo
        </button>
      </div>
    </div>

    <!-- ─── ABA IMP_FORMS ────────────────────────────────────────── -->
    <div class="imp-body" *ngIf="importAba==='forms'">
      <p class="imp-desc">
        Uma linha por form disponível. Colunas: <code>APE_ID, EMP_ID, ICO_FORM_NUMERO, ICO_FORM_LOTE, ICO_FORM_DATA_VAL, SALDO_FORM</code>
      </p>
      <div class="imp-upload-row">
        <label class="btn-upload">
          {{ csvFormsNome() || 'Selecionar CSV' }}
          <input type="file" accept=".csv" style="display:none" (change)="onFileChangeCsvForms($event)">
        </label>
        <span class="imp-status ok" *ngIf="csvFormsImportado()>0">✓ {{csvFormsImportado()}} registros na tabela</span>
        <span class="imp-status info" *ngIf="!csvFormsImportado()">Opcional — apenas produtos com controle de lote</span>
      </div>

      <div class="map-grid" *ngIf="csvFormsHeaders.length">
        <div class="map-row">
          <label>APE_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapForms.apeId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EMP_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapForms.empId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>ICO_FORM_NUMERO</label>
          <select [(ngModel)]="mapForms.formNumero">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>ICO_FORM_LOTE</label>
          <select [(ngModel)]="mapForms.formLote">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>ICO_FORM_DATA_VAL</label>
          <select [(ngModel)]="mapForms.formDataVal">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>SALDO_FORM</label>
          <select [(ngModel)]="mapForms.saldoForm">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvFormsHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
      </div>

      <div class="imp-footer">
        <button class="modal-btn" (click)="importAba='base'">Anterior</button>
        <button class="modal-btn confirm"
                [disabled]="!csvFormsHeaders.length || csvFormsImportando()"
                (click)="importarForms()"><app-loading-indicator *ngIf="csvFormsImportando()" size="inline"></app-loading-indicator>
          {{ csvFormsImportando() ? 'Importando...' : 'Importar IMP_FORMS' }}
        </button>
        <button class="modal-btn" (click)="importAba='seriais'">Próximo</button>
      </div>
    </div>

    <!-- ─── ABA IMP_SERIAIS ──────────────────────────────────────── -->
    <div class="imp-body" *ngIf="importAba==='seriais'">
      <p class="imp-desc">
        Uma linha por serial disponível. Colunas: <code>APE_ID, EMP_ID, ICS_NS</code>
      </p>
      <div class="imp-upload-row">
        <label class="btn-upload">
          {{ csvSeraisNome() || 'Selecionar CSV' }}
          <input type="file" accept=".csv" style="display:none" (change)="onFileChangeCsvSeriais($event)">
        </label>
        <span class="imp-status ok" *ngIf="csvSeraisImportado()>0">✓ {{csvSeraisImportado()}} registros na tabela</span>
        <span class="imp-status info" *ngIf="!csvSeraisImportado()">Opcional — apenas produtos com controle de série</span>
      </div>

      <div class="map-grid" *ngIf="csvSeraisHeaders.length">
        <div class="map-row">
          <label>APE_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapSeriais.apeId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvSeraisHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>EMP_ID <span class="req">*</span></label>
          <select [(ngModel)]="mapSeriais.empId">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvSeraisHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
        <div class="map-row">
          <label>ICS_NS (Número de Série) <span class="req">*</span></label>
          <select [(ngModel)]="mapSeriais.icsNs">
            <option value="">-- selecione --</option>
            <option *ngFor="let h of csvSeraisHeaders" [value]="h">{{h}}</option>
          </select>
        </div>
      </div>

      <div class="imp-footer">
        <button class="modal-btn" (click)="importAba='forms'">Anterior</button>
        <button class="modal-btn confirm"
                [disabled]="!csvSeraisHeaders.length || csvSeraisImportando()"
                (click)="importarSeriais()"><app-loading-indicator *ngIf="csvSeraisImportando()" size="inline"></app-loading-indicator>
          {{ csvSeraisImportando() ? 'Importando...' : 'Importar IMP_SERIAIS' }}
        </button>
        <button class="modal-btn" (click)="importAba='nota'; carregarPreview()"
                [disabled]="!podeAbrirNota">
          Gerar Nota
        </button>
      </div>
    </div>

    <!-- ─── ABA GERAR NOTA ───────────────────────────────────────── -->
    <div class="imp-body nota-body" *ngIf="importAba==='nota'">

      <!-- Barra de progresso durante a geração da nota -->
      <div class="exec-progresso-wrap" *ngIf="execCarregando()">
        <div class="exec-progresso-label">{{execEmpresaAtual() || 'Gerando nota(s)...'}} — {{execProgresso()}}%</div>
        <div class="exec-progresso-track">
          <div class="exec-progresso-fill" [style.width.%]="execProgresso()"></div>
        </div>
      </div>

      <!-- Resultado final (após execução) -->
      <div class="exec-resultado" *ngIf="execResultado.length">
        <div class="exec-resultado-titulo">✓ Nota(s) gerada(s) com sucesso!</div>
        <div class="imp-error" *ngIf="execMensagem() && execMensagem().includes('aviso')">⚠ {{execMensagem()}}</div>
        <table class="imp-table">
          <thead><tr><th>Empresa (Sankhya)</th><th>NUNOTA</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of execResultado">
              <td>{{r.empresa}}</td>
              <td><strong>{{r.nunota}}</strong></td>
            </tr>
          </tbody>
        </table>
        <div class="imp-footer">
          <button class="modal-btn" (click)="fecharImportacao()">Fechar</button>
        </div>
      </div>

      <!-- Itens não importados (produtos inativos, sem quantidade, empresa com erro etc.) -->
      <div class="exec-nao-importados" *ngIf="execItensNaoImportados.length">
        <div class="exec-resultado-titulo aviso">⚠ {{execItensNaoImportados.length}} item(ns) não importado(s)</div>
        <div class="imp-table-scroll">
          <table class="imp-table">
            <thead><tr><th>Emp</th><th>CODPROD</th><th>Descrição</th><th>Motivo</th></tr></thead>
            <tbody>
              <tr *ngFor="let it of execItensNaoImportados">
                <td>{{it.codemp}}</td>
                <td>{{it.codprod}}</td>
                <td class="td-descr">{{it.descrprod || '-'}}</td>
                <td>{{it.motivo}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Parâmetros + Preview (antes da execução) -->
      <ng-container *ngIf="!execResultado.length">
        <div class="imp-error" *ngIf="execErro()">⚠ {{execErro()}}</div>

        <!-- Empresas -->
        <div class="emp-section">
          <h4>Empresas</h4>
          <div class="emp-table-wrap">
            <table class="emp-table">
              <thead>
                <tr>
                  <th class="emp-check"></th>
                  <th class="emp-codemp">Sankhya</th>
                  <th>Origem (Aerosys)</th>
                  <th class="emp-codparc">CODPARC</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of empresas" [class.inativo]="!e.ativo">
                  <td class="emp-check">
                    <input type="checkbox" [(ngModel)]="e.ativo">
                  </td>
                  <td class="emp-codemp">Emp {{e.codemp}}</td>
                  <td><span class="emp-detalhe">{{e.detalhe}}</span></td>
                  <td class="emp-codparc">
                    <input type="number" [(ngModel)]="e.codparc" [disabled]="!e.ativo">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Parâmetros fixos -->
        <div class="nota-fixed-params">
          <h4>Parâmetros da Nota</h4>
          <div class="fixed-grid">
            <div class="fixed-row"><label>Tipo Negociação</label><input type="number" [(ngModel)]="execParams.tipneg"></div>
            <div class="fixed-row"><label>Natureza (CODNAT)</label><input type="text" [(ngModel)]="execParams.codnat"></div>
            <div class="fixed-row"><label>Tipo Operação</label><input type="number" [(ngModel)]="execParams.codtipoper"></div>
            <div class="fixed-row"><label>Centro de Resultado</label><input type="number" [(ngModel)]="execParams.codcencus"></div>
            <div class="fixed-row"><label>Projeto</label><input type="number" [(ngModel)]="execParams.codprojeto"></div>
            <div class="fixed-row"><label>Tabela de Preço</label><input type="number" [(ngModel)]="execParams.codtab"></div>
          </div>
        </div>

        <!-- Preview -->
        <div class="preview-section">
          <div class="preview-header-row">
            <h4>Pré-visualização dos Itens</h4>
            <button class="modal-btn" (click)="carregarPreview()" [disabled]="previewCarregando()"><app-loading-indicator *ngIf="previewCarregando()" size="inline"></app-loading-indicator>
              {{ previewCarregando() ? 'Carregando...' : 'Atualizar Preview' }}
            </button>
          </div>

          <div class="preview-stats" *ngIf="previewItens.length">
            <span>{{previewItens.length}} itens (TGFITE)</span>
            <span *ngIf="previewFormsCount">· {{previewFormsCount}} forms (TGFEST)</span>
            <span *ngIf="previewSeraisCount">· {{previewSeraisCount}} seriais (TGFSER)</span>
          </div>

          <div class="preview-loading" *ngIf="previewCarregando()"><app-loading-indicator size="inline"></app-loading-indicator> Carregando preview...</div>

          <div class="preview-empty" *ngIf="!previewCarregando() && !previewItens.length">
            Clique em "Atualizar Preview" para visualizar os itens que serão inseridos.
          </div>

          <div class="preview-table-wrap" *ngIf="previewItens.length">
            <table class="imp-table imp-table-scroll">
              <thead>
                <tr>
                  <th>Emp</th>
                  <th>CODPROD</th>
                  <th>Descrição</th>
                  <th>PN</th>
                  <th>Local</th>
                  <th>Qtd</th>
                  <th>Custo</th>
                  <th>Venda</th>
                  <th>Controle</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let it of previewItens">
                  <td>{{it.codemp}}</td>
                  <td>{{it.codprod}}</td>
                  <td class="td-descr">{{it.descrprod}}</td>
                  <td>{{it.refforn}}</td>
                  <td>{{it.descrlocal || it.codlocal}}</td>
                  <td>{{it.qtd}}</td>
                  <td>{{it.custo}}</td>
                  <td>{{it.vlrvenda}}</td>
                  <td>{{it.controle}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="imp-footer">
          <button class="modal-btn" (click)="importAba='seriais'">Anterior</button>
          <button class="modal-btn confirm exec-btn"
                  [disabled]="!previewItens.length || execCarregando()"
                  (click)="executarNota()"><app-loading-indicator *ngIf="execCarregando()" size="inline"></app-loading-indicator>
            {{ execCarregando() ? 'Executando...' : 'Confirmar e Gerar Nota' }}
          </button>
        </div>
      </ng-container>
    </div>

  </div>
</div>

<!-- MODAL PRODUTOS ALTERNATIVOS (CADASTRO) -->
<div class="modal-overlay produtos-alternativos-modal-overlay" *ngIf="modalProdutosAlternativosAberto">
    <div class="modal-box produtos-alternativos-modal" (click)="$event.stopPropagation()">
        <div class="modal-header produtos-alternativos-modal-header">
            <div>
                <strong>Produtos Alternativos</strong>
                <span>Busque e selecione um ou mais produtos</span>
            </div>
            <button type="button" class="produtos-alternativos-modal-close" (click)="modalProdutosAlternativosAberto = false">x</button>
        </div>

        <div class="modal-body produtos-alternativos-modal-body">
            <div class="produtos-alternativos-filtros">
                <label class="produtos-alternativos-termo">
                    Produto
                    <input
                            type="text"
                            [(ngModel)]="filtroProdutoAlternativo"
                            (input)="aoDigitarProdutoAlternativoCadastro()"
                            placeholder="Código, Part Number ou descrição">
                </label>
                <label>
                    Marca
                    <div class="fabricante-search-wrap produtos-alternativos-marca-search">
                        <input
                                type="text"
                                [value]="marcaProdutoAlternativoDescricao"
                                placeholder="Todas as marcas"
                                readonly
                                (click)="abrirModalFabricantesCadastro()">
                        <button
                                type="button"
                                class="produtos-alternativos-marca-limpar"
                                *ngIf="marcaProdutoAlternativo"
                                (click)="$event.stopPropagation(); marcaProdutoAlternativo = ''; marcaProdutoAlternativoDescricao = ''; buscarProdutosAlternativosModal()">x</button>
                    </div>
                </label>
            </div>

            <div class="produtos-alternativos-selecionados" *ngIf="produtosAlternativosSelecionados.length">
                <span *ngFor="let produto of produtosAlternativosSelecionados">
                    PN: {{ produto.partNumber || produto.codprod }}
                    <button type="button" (click)="alternarProdutoAlternativoCadastro(produto)">x</button>
                </span>
            </div>

            <div class="produtos-alternativos-loading" *ngIf="carregandoProdutosAlternativos">
                <app-loading-indicator></app-loading-indicator> Carregando produtos...
            </div>

            <div class="produtos-alternativos-lista" *ngIf="!carregandoProdutosAlternativos">
                <div class="alt-resultados-container">
                    <table class="alt-table" *ngIf="produtosAlternativosBusca.length > 0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Código</th>
                            <th>Part Number</th>
                            <th>Marca</th>
                            <th>Descrição</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let prod of produtosAlternativosBusca" (click)="alternarProdutoAlternativoCadastro(prod)"
                            [class.alt-selecionado]="produtoAlternativoSelecionadoCadastro(prod)">
                            <td>
                                <input type="checkbox" [checked]="produtoAlternativoSelecionadoCadastro(prod)" (click)="$event.stopPropagation()" (change)="alternarProdutoAlternativoCadastro(prod)">
                            </td>
                            <td>{{ prod.codprod }}</td>
                            <td [title]="prod.partNumber">{{ prod.partNumber }}</td>
                            <td [title]="prod.marca">{{ prod.marca }}</td>
                            <td>{{ prod.descricao }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="alt-empty-state" *ngIf="produtosAlternativosBusca.length === 0 && !carregandoProdutosAlternativos">
                        Nenhum produto encontrado.
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="modal-btn cancel" (click)="modalProdutosAlternativosAberto = false">Cancelar</button>
            <button type="button" class="modal-btn confirm" (click)="modalProdutosAlternativosAberto = false">
                Confirmar ({{ produtosAlternativosSelecionados.length }})
            </button>
        </div>
    </div>
</div>
